(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurisa-quick-add-fix"] && !Shopify.designMode) return;
  try {
    class AurisaQuickAddFix extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.pending = new Set();
    this.timers = new Set();
    this.popup = null;
    this.prefixes = ['bst', 'aua', 'tee', 'bnb', 'au'];
    this.mobile = matchMedia('(max-width: 749px)');
    this.querySelector('.au-quick-confirmation__close').addEventListener('click', () => this.hideConfirmation(), { signal: this.controller.signal });
    window.addEventListener('click', this.handleClick, { capture: true, signal: this.controller.signal });
    window.addEventListener('pointerdown', this.handleOutside, { capture: true, signal: this.controller.signal });
    window.addEventListener('pointermove', this.handleMove, { capture: true, passive: true, signal: this.controller.signal });
    window.addEventListener('pointerup', () => { this.pointerStart = null; }, { signal: this.controller.signal });
    window.addEventListener('pointercancel', () => { this.pointerStart = null; this.dragged = true; }, { signal: this.controller.signal });
    window.addEventListener('keydown', this.handleKey, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.hideConfirmation();
    this.closePopup();
    this.controller?.abort();
    this.controller = null;
    for (const timer of this.timers ?? []) clearTimeout(timer);
  }

  closePopup(popup = this.popup) {
    if (!popup || popup !== this.popup) return;
    popup.classList.remove('open');
    if (typeof popup.hidePopover === 'function' && popup.matches(':popover-open')) popup.hidePopover();
    if (this.locked) {
      document.documentElement.style.overflow = this.previousHtmlOverflow;
      document.body.style.overflow = this.previousBodyOverflow;
    }
    if (popup.contains(document.activeElement) && this.opener?.isConnected) {
      this.opener.focus({ preventScroll: true });
    }
    this.popup = null;
    this.locked = false;
  }

  openPopup(popup, opener, keyboard) {
    this.closePopup();
    this.popup = popup;
    this.opener = opener;
    popup.setAttribute('data-aurisa-quick-size', '');
    popup.classList.add('open');
    if (typeof popup.showPopover === 'function') {
      popup.setAttribute('popover', 'manual');
      popup.showPopover();
    }
    this.locked = !this.mobile.matches;
    if (this.locked) {
      this.previousHtmlOverflow = document.documentElement.style.overflow;
      this.previousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    if (keyboard) popup.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
  }

  handleOutside = event => {
    this.pointerStart = { x: event.clientX, y: event.clientY };
    this.dragged = false;
    if (this.popup && !this.popup.lastElementChild?.contains(event.target) && !this.opener?.contains(event.target)) {
      this.closePopup();
    }
  };

  handleMove = event => {
    if (this.pointerStart && (Math.abs(event.clientX - this.pointerStart.x) > 5 || Math.abs(event.clientY - this.pointerStart.y) > 5)) {
      this.dragged = true;
    }
  };

  handleKey = event => {
    if (event.key === 'Escape') { this.closePopup(); this.hideConfirmation(); }
  };

  hideConfirmation() {
    clearTimeout(this.confirmationTimer);
    const notice = this.querySelector('.au-quick-confirmation');
    if (typeof notice.hidePopover === 'function' && notice.matches(':popover-open')) notice.hidePopover();
    notice.hidden = true;
  }

  async showConfirmation(result) {
    const notice = this.querySelector('.au-quick-confirmation');
    const shipping = notice.querySelector('.au-quick-confirmation__shipping');
    const version = this.confirmationVersion = (this.confirmationVersion || 0) + 1;
    notice.querySelector('.au-quick-confirmation__product').textContent = [result.product_title || result.title, result.variant_title].filter(Boolean).join(' · ');
    shipping.textContent = 'Gratis verzending vanaf €80';
    notice.hidden = false;
    if (typeof notice.showPopover === 'function' && !notice.matches(':popover-open')) notice.showPopover();
    clearTimeout(this.confirmationTimer);
    this.confirmationTimer = setTimeout(() => this.hideConfirmation(), 10000);
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== this.confirmationVersion || !this.isConnected || cart.currency !== 'EUR') return;
      const remaining = Math.max(0, 8000 - cart.total_price);
      const amount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(remaining / 100);
      shipping.textContent = remaining > 0 ? `Nog ${amount} tot gratis verzending` : '✓ Je krijgt gratis verzending!';
      this.querySelector('[role="status"]').textContent = `${this.dataset.success}. ${shipping.textContent}`;
    } catch { /* The successful add confirmation remains visible if cart totals cannot load. */ }
  }

  handleClick = event => {
    if (!(event.target instanceof Element) || event.button > 0) return;
    for (const prefix of this.prefixes) {
      const attributes = ['card-add', 'mobile-card-add', 'mobile-add', 'open-size', 'close-size', 'open-notify'];
      const button = event.target.closest(attributes.map(name => `[data-${prefix}-${name}]`).join(','));
      const section = button?.closest(`[data-${prefix}]`);
      if (!button || !section) continue;
      if (event.detail > 0 && this.dragged) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (button.hasAttribute(`data-${prefix}-open-notify`)) {
        this.closePopup();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.disabled) return;
      if (button.hasAttribute(`data-${prefix}-close-size`)) {
        this.closePopup();
        return;
      }
      if (button.hasAttribute(`data-${prefix}-open-size`)) {
        const id = button.getAttribute(`data-${prefix}-open-size`);
        const popup = Array.from(section.querySelectorAll(`.${prefix}_size_pop`))
          .find(node => node.getAttribute(`data-${prefix}-size`) === id);
        if (popup) this.openPopup(popup, button, event.detail === 0);
        return;
      }
      const id = ['card-add', 'mobile-card-add', 'mobile-add']
        .map(name => button.getAttribute(`data-${prefix}-${name}`)).find(Boolean);
      if (id) this.add(id, button, prefix);
      return;
    }
  };

  async add(id, button, prefix) {
    if (this.pending.has(id)) return;
    this.pending.add(id);
    const popup = button.closest(`.${prefix}_size_pop`);
    const message = popup?.querySelector(`[data-${prefix}-msg]`);
    const original = button.innerHTML;
    const live = this.querySelector('[role="status"]');
    live.textContent = '';
    button.disabled = true;
    button.classList.add('is_loading');
    button.textContent = this.dataset.adding;
    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    if (prefix === 'aua') {
      body.append('properties[Pre order]', 'Aura One Piece pre order');
      body.append('properties[Maatadvies]', 'Wij raden 1 maat groter aan');
    }
    const restore = () => {
      button.disabled = false;
      button.classList.remove('is_loading');
      button.innerHTML = original;
      this.pending.delete(id);
    };
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', body, headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.error);
      button.textContent = this.dataset.added;
      live.textContent = this.dataset.success;
      this.showConfirmation(result);
      for (const name of ['cart:refresh', 'cart:updated', 'aurisa:cart-updated']) {
        document.dispatchEvent(new CustomEvent(name));
      }
      for (const name of ['cart:refresh', 'cart:updated']) window.dispatchEvent(new CustomEvent(name));
      if (typeof window.AurisaCart?.refresh === 'function') {
        try { Promise.resolve(window.AurisaCart.refresh()).catch(() => {}); } catch {}
      }
      const timer = setTimeout(() => {
        this.closePopup(popup);
        restore();
        this.timers.delete(timer);
      }, 220);
      this.timers.add(timer);
    } catch (error) {
      const text = error.message || this.dataset.error;
      if (message) message.textContent = text;
      live.textContent = text;
      restore();
    }
  }
}

if (!customElements.get('aurisa-quick-add-fix')) customElements.define('aurisa-quick-add-fix', AurisaQuickAddFix);
  } catch(e) { console.error(e); }
})();

})();
